function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M384,256c-17.7,0-32,14.3-32,32s14.3,32,32,32s32-14.3,32-32S401.7,256,384,256z M464,96h-16V80 c0-26.5-21.5-48-48-48H96C43,32,0,75,0,128v256c0,53,43,96,96,96h352c35.4,0,64-28.6,64-64V144C512,117.5,490.5,96,464,96z M480,416 c0,17.6-14.4,32-32,32H96c-35.3,0-64-28.7-64-64V128c0-35.3,28.7-64,64-64h304c8.8,0,16,7.2,16,16v16H112c-8.8,0-16,7.2-16,16 s7.2,16,16,16h352c8.8,0,16,7.2,16,16V416z"
});

var SvgIconOpenPositions = function SvgIconOpenPositions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOpenPositions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_open_positions.4bfb0c78.svg";
export { ForwardRef as ReactComponent };